export const IS_REGISTERED = "registered"
export const IS_NEW = "new"